import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

export class SebTextField extends LitElement {
  static shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
  };

  static styles = css`
    :host {
      display: block;
      color: var(--seb-text-color, #111927);
    }

    :host:focus,
    :host label:focus {
      outline: none;
    }

    :host label {
      position: relative;
      height: 55px;
      width: 100%;
      box-sizing: border-box;
      transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    :host label span {
      position: absolute;
      top: -10px;
      left: 12px;
      -webkit-text-size-adjust: 100%;
      -webkit-font-smoothing: antialiased;
      color-scheme: light;
      --Grid-columns: 12;
      --Grid-columnSpacing: 32px;
      --Grid-rowSpacing: 32px;
      box-sizing: border-box;
      color: #6C737F;
      line-height: 1.4375em;
      font-family: "Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji";
      padding: 0;
      font-size: 14px;
      font-weight: 500;
      display: block;
      transform-origin: top left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 24px);
      transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
      z-index: 1;
      pointer-events: none;
    }

    :host label span.focus,
    :host label span.with-content {
      top: -18px;
      transform: scale(0.75);
    }

    :host label input {
      font: inherit;
      letter-spacing: inherit;
      height: 55px;
      margin: 0;
      -webkit-tap-highlight-color: transparent;
      min-width: 0;
      padding: 25px 12px 8px;
      -webkit-text-size-adjust: 100%;
      -webkit-font-smoothing: antialiased;
      color-scheme: light;
      --Grid-columns: 12;
      --Grid-columnSpacing: 32px;
      --Grid-rowSpacing: 32px;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.4375em;
      font-family: "Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji";
      color: #111927;
      box-sizing: border-box;
      cursor: text;
      display: inline-flex;
      -webkit-box-align: center;
      align-items: center;
      width: 100%;
      position: relative;
      background-color: transparent;
      border-radius: 8px;
      border-style: solid;
      border-width: 1px;
      overflow: hidden;
      transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      border-color: #E5E7EB;
    }

    :host label input:focus {
      outline: none;
      border: 2px solid var(--seb-primary-color, #6366F1);
    }
  `;

  @property({ type: Boolean }) checked = false;

  @property({ type: String }) name = '';

  @property({ type: String }) value = '';

  @property({ type: String }) label = 'Label';


  __handleClick() {
    this.checked = !this.checked;
  }

  __handleFocus() {
    this.shadowRoot?.querySelector('span')?.classList.add('focus');
  }

  __handleBlur() {
    this.shadowRoot?.querySelector('span')?.classList.remove('focus');
  }

  __handleInput(e: Event) {
    this.value = (e.target as HTMLInputElement).value;
    this.dispatchEvent(new CustomEvent('input', { detail: this.value }));
  }

  render() {
    return html`
      <label>
        <span class=${this?.value?.length ? 'with-content' : ''}>
          ${this.label}
        </span>
        <input
          role='presentation'
          autocomplete="off"
          type='text'
          name=${this.name || ''}
          .value=${this.value || ''}
          @click=${this.__handleClick}
          @focus=${this.__handleFocus}
          @blur=${this.__handleBlur}
          @input=${this.__handleInput}
        >
        <slot></slot>
      </label>
    `;
  }
}
